/* global encodeURIComponent, Promise */
import "whatwg-fetch";

export default class AjaxHelper {
    static ajaxStatus(response) {
        if (response.status >= 200 && response.status < 300) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    }

    static getContentTypeHeader(headers) {
        headers.append("Content-Type", "application/json");
    }

    static getCampusApiKeyHeader(headers, campusApiKey, campusApiSecret) {
        if (campusApiKey) {
            headers.append("Campus_Api_Key", campusApiKey);
        }
        if (campusApiSecret) {
            headers.append("Campus_Api_Secret", campusApiSecret);
        }
    }

    static getUrl(url, input, method) {
        if(input === null) {
            return url;
        }
        if (method !== "PUT" || method !== "POST") {
            const esc = encodeURIComponent;
            const query = Object.keys(input).map(k => input[k] !== null? esc(k) + '=' + esc(input[k]) : esc(k) + '=' ).join('&');
            return `${url}?${query}`;
        }
        return url;
    }

    static __doAjaxCall(method, url, input, headers, successCallback, errorCallback, alwaysCallback) {
        const request = new Request(
            AjaxHelper.getUrl(url, input, method, headers),
            {
                method: method,
                mode: "cors",
                headers:headers,
                credentials: "include",
                cache: "no-cache",
                body: (method === "PUT" || method === "POST") ? JSON.stringify(input, null, 2) : undefined
            });
        return window.fetch(request)
            .then(response => AjaxHelper.ajaxStatus(response))
            .then(response => {
                var contentType = response.headers.get("content-type");
                if (contentType && contentType.indexOf("application/json") !== -1) {
                    return response.json()
                        .then(output => {
                            successCallback(output);
                        });
                } else {
                    successCallback(response.statusText);
                }
            })
            .catch(response => {
                errorCallback(response.status, response.statusText);
              
            }).then(() => {
                if (alwaysCallback) {
                    alwaysCallback();
                }
            });
    }

    static "get"(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        var headers = new Headers();
        AjaxHelper.getContentTypeHeader(headers);
        AjaxHelper.getCampusApiKeyHeader(headers, apiKey, apiSecret)
        return AjaxHelper.__doAjaxCall("GET", url, input, headers, successCallback, errorCallback, alwaysCallback);
    }
    static "post"(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        var headers = new Headers();
        AjaxHelper.getContentTypeHeader(headers)
        AjaxHelper.getCampusApiKeyHeader(headers, apiKey, apiSecret)
        return AjaxHelper.__doAjaxCall("POST", url, input, headers, successCallback, errorCallback, alwaysCallback);
    }

    static "put"(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        var headers = new Headers();
        AjaxHelper.getContentTypeHeader(headers);
        AjaxHelper.getCampusApiKeyHeader(headers, apiKey, apiSecret)
        return AjaxHelper.__doAjaxCall("PUT", url, input, headers, successCallback, errorCallback, alwaysCallback);
    }

    static "delete"(url, input, apiKey, apiSecret, successCallback, errorCallback, alwaysCallback) {
        var headers = new Headers();
        AjaxHelper.getContentTypeHeader(headers);
        AjaxHelper.getCampusApiKeyHeader(headers, apiKey, apiSecret)
        return AjaxHelper.__doAjaxCall("DELETE", url, input, headers, successCallback, errorCallback, alwaysCallback);
    }
}

